import React from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import fcbLogo from 'assets/images/foodcourt-business-logo.png';
import { DateRangeType } from '@cokitchen/cokitchen-components';
import moment from 'moment';
import { formatCurrency } from 'utils/functions';
import { TransactionSummaryType } from 'models/transactions.model';

type Props = {
  elementRef: React.LegacyRef<HTMLDivElement>;
  dateRange: DateRangeType['date'];
  summary: TransactionSummaryType;
};

const StatementSummary = (props: Props) => {
  const { elementRef, dateRange, summary } = props;
  const { activeCompany } = useDashboardContext();

  return (
    <div ref={elementRef} className='fixed -top-[200vh] -z-10 w-[595px]'>
      <div className='flex items-start justify-between px-[22px] pt-6 pb-4 border-b border-[#EAEAEB]'>
        <img src={fcbLogo} className='w-[109px]' />
        <article className='max-w-[138px] text-right'>
          <p className='text-xs font-semibold'>{activeCompany.name}</p>
          <p className='text-[10px] leading-[16px]'>{activeCompany.address}</p>
        </article>
      </div>
      <div className='flex flex-col gap-3 px-[22px] pt-6'>
        <article>
          <p className='text-xs font-medium text-[#E60A2B]'>Account Summary</p>
          <p className='text-[10px] leading-4 text-[#2E3031]'>
            {moment(dateRange.startDate).format('MMM D, YYYY')}&nbsp;-&nbsp;
            {moment(dateRange.endDate).format('MMM D, YYYY')}
          </p>
        </article>
        <div className='flex border-[0.8px] border-[#EAEAEB] bg-[#F9F9F9] text-[10px] leading-4'>
          <div className='w-[70%] flex flex-col border-r border-[#EAEAEB]'>
            <ul className='flex flex-col gap-2 p-4 border-b border-[#EAEAEB]'>
              <li className='flex items-center justify-between'>
                <p>Opening balance</p>
                <p className='text-[#5E6164]'>{formatCurrency(summary.opening_balance)}</p>
              </li>
              <li className='flex items-center justify-between'>
                <p>Credit</p>
                <p className='text-[#5E6164]'>{formatCurrency(summary.total_deposit)}</p>
              </li>
              <li className='flex items-center justify-between'>
                <p>Orders placed</p>
                <p className='text-[#5E6164]'>{formatCurrency(summary.order_total)}</p>
              </li>
              <li className='flex items-center justify-between'>
                <p>Total gifts</p>
                <p className='text-[#5E6164]'>{formatCurrency(summary.total_gift)}</p>
              </li>
              <li className='flex items-center justify-between'>
                <p>Total events</p>
                <p className='text-[#5E6164]'>{formatCurrency(summary.total_event_allocation)}</p>
              </li>
              <li className='flex items-center justify-between'>
                <p>Staff allocation</p>
                <p className='text-[#5E6164]'>{formatCurrency(summary.staff_allocation)}</p>
              </li>
            </ul>
            <div className='flex items-center justify-between gap-3 px-4 mt-2 mb-5'>
              <p className='font-medium'>Closing balance</p>
              <p className='font-medium'>{formatCurrency(summary.closing_balance)}</p>
            </div>
          </div>
          <div className='w-[30%] flex flex-col justify-center gap-2 p-4'>
            <p># of Credits: {summary.deposit_count}</p>
            <p># of Debits: {summary.debit_count}</p>
            <p># of Staff Billed for: {summary.staff_billed_count}</p>
            <p># of Orders Completed: {summary.completed_orders}</p>
            <p># of Orders Cancelled: {summary.cancelled_orders}</p>
            <p># of Orders Rejected: {summary.rejected_orders}</p>
          </div>
        </div>
        <p className='text-xs font-medium text-[#E60A2B] py-4'>Transaction Breakdown</p>
      </div>
    </div>
  );
};

export default StatementSummary;
